import React from 'react';
import { AlertTriangle, MapPin } from 'lucide-react';
import { Modal } from '@/shared/components/ui';
import { Button } from '@/shared/components/ui/Button';

interface RoomNotAssignedModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

const RoomNotAssignedModal: React.FC<RoomNotAssignedModalProps> = ({
  isOpen,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onConfirm}
      closeOnOverlayClick={false}
      showCloseButton={false}
      title={
        <div className="flex items-center gap-3">
          <div className="bg-amber-100 p-3 rounded-full">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
          <span>Room Not Assigned</span>
        </div>
      }
      size="md"
      footer={
        <Button
          onClick={onConfirm}
          variant="warning"
          fullWidth
          padding="px-4 py-2"
          className="font-medium"
        >
          OK, Log Me Out
        </Button>
      }
    >
      <div className="space-y-4">
          <div className="flex items-start gap-3">
            <MapPin className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" />
            <div className="text-gray-700">
              <p className="font-medium mb-2">
                This device has not been assigned to a room yet.
              </p>
              <p className="text-sm text-gray-600 mb-4">
                Please contact your administrator or IT support to set up the room
                configuration for this terminal.
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm text-blue-800">
                <p className="font-medium mb-1">What to do:</p>
                <ol className="list-decimal list-inside space-y-1 ml-2">
                  <li>Contact your system administrator</li>
                  <li>Ask them to log in on this device</li>
                  <li>They will configure the room settings</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
    </Modal>
  );
};

export default RoomNotAssignedModal;
